module.exports = __webpack_public_path__ + "static/media/cassette-tapes.06302cd9.jpg";